import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'medaljtyp',
    pure: false
})
export class MedaljtypPipe implements PipeTransform {
    transform(items: any[], filter: number): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter(item => item.medalj.medaljtyp.data.id === filter);
    }
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/medaljtyp.pipe.ts